import { useQuery } from "@tanstack/react-query";
import { fetchWholesaleSales, type WholesaleSalesRawResponse } from "../services/wholesaleSalesService";

export const useWholesaleSales = (startDate: string, endDate: string) => {
  return useQuery<WholesaleSalesRawResponse>({
    queryKey: ["wholesale-sales-dashboard", startDate, endDate],
    queryFn: () => fetchWholesaleSales(startDate, endDate),
    staleTime: 5 * 60 * 1000,
  });
};
